import * as types from './../constants/actionTypes';
import initialState from './initialState';

export default function (state = initialState.chartOfAccounts, action) {
   switch (action.type) {
      case types.LOAD_CHART_OF_ACCOUNT_SUCCESS :
         return action.payload.chartOfAccounts;
      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/chartOfAccountReducers.js
 **/